import { render, staticRenderFns } from "./SysDataSourceList.vue?vue&type=template&id=815b296e&scoped=true"
import script from "./SysDataSourceList.vue?vue&type=script&lang=js"
export * from "./SysDataSourceList.vue?vue&type=script&lang=js"
import style0 from "./SysDataSourceList.vue?vue&type=style&index=0&id=815b296e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "815b296e",
  null
  
)

export default component.exports